/**
 * Display formatting. Formatter construction is the expensive part of Intl, so
 * each one is built once at module scope rather than per render.
 *
 * `undefined` as the locale means "whatever the browser is set to" — dates in
 * this portal are read by both an Australian agency and its clients, and neither
 * should be shown the other's conventions.
 */

const DATE = new Intl.DateTimeFormat(undefined, {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

const DATE_TIME = new Intl.DateTimeFormat(undefined, {
  day: 'numeric',
  month: 'short',
  hour: 'numeric',
  minute: '2-digit',
});

/** Timestamps arrive as ISO-8601 UTC strings (see `Timestamp` in @rundown/types). */
export function formatDate(timestamp: string): string {
  const date = new Date(timestamp);
  return Number.isNaN(date.getTime()) ? '—' : DATE.format(date);
}

export function formatDateTime(timestamp: string): string {
  const date = new Date(timestamp);
  return Number.isNaN(date.getTime()) ? '—' : DATE_TIME.format(date);
}

/** Hours are the primary estimate unit; whole numbers unless the half matters. */
export function formatHours(hours: number): string {
  if (!Number.isFinite(hours)) return '—';
  const rounded = Math.round(hours * 2) / 2;
  return `${Number.isInteger(rounded) ? rounded.toString() : rounded.toFixed(1)}h`;
}
